import {
    $get,
    $del,
    $put,
    $post,
    $post2,
    $post3
} from "@/utils/request";

// 登录
export const login = (data) => {
    // return $post("/user/check", data);
    return $post("/user/baseApi", {
        type: 4,
        ...data
    });
};

// 3.3.6请求用户信息
export const getUserInfo = (data) => {
    // return $post("/user/getUser", data);
    return $post("/user/baseApi", {
        type: 6,
        ...data
    });
};

// 请求团队信息
export const getGroupList = (data) => {
    // return $post("/user/queryGroupList", data);
    return $post("/user/baseApi", {
        type: 16,
        ...data
    });
};

// 修改用名字
export const changeUsername = (data) => {
    // return $post("/user/updateNickName", data);
    return $post("/user/baseApi", {
        type: 8,
        ...data
    });
};

// 修改密码
export const changePassword = (data) => {
    // return $post("/user/updatePwd", data);
    return $post("/user/baseApi", {
        type: 3,
        ...data
    });
};
// 修改密码
export const signOut = () => {
    // return $post("/user/signOut");
    return $post("/user/baseApi", {
        type: 32
    });
};

// /user/updateAccount2ndAuthSetting
export const update2ndAuth = (data) => {
    // return $post("/user/updateAccount2ndAuthSetting", data);
    return $post("/user/baseApi", {
        type: 36,
        ...data
    });
};
// 获取个人设备列表
export const getPersonalDeviceList = (data) => {
    // return $post("/user/loadDrive", data);
    return $post("/user/baseApi", {
        type: 12,
        ...data
    });
};

// 个人设备列表修改备注
export const updateMemo = (data) => {
    return $post("/user/removeDrive", data);
};

// 个人设备列表解除绑定
export const unbindDrive = (data) => {
    // return $post("/user/unbindDrive", data);
    return $post("/user/baseApi", {
        type: 14,
        ...data
    });
};

// 修改团队的名称
export const updateGroupName = (data) => {
    // return $post("/user/updateGroupName", data);
    return $post("/user/baseApi", {
        type: 17,
        ...data
    });
};

// 退出团队
export const quitGroup = (data) => {
    // return $post("/user/signOutGroup", data);

    return $post("/user/baseApi", {
        type: 18,
        ...data
    });
};

// 获取设备分组
export const getGroupAside = (data) => {
    // return $post("/user/queryGroupDivideList", data);
    return $post("/user/baseApi", {
        type: 19,
        ...data
    });
};

// 获取所有团队设
export const getGroupDevs = (data) => {
    // return $post("/user/getGroupDevs", data);
    return $post("/user/baseApi", {
        type: 23,
        ...data
    });
};

// 修改团队设备备注
export const updateGroupDevRemarks = (data) => {
    // return $post("/user/updateGroupDevRemarks", data);
    return $post("/user/baseApi", {
        type: 24,
        ...data
    });
};

// 删除团队设备
export const deleteGroupDev = (data) => {
    // return $post("/user/deleteGroupDev", data);
    return $post("/user/baseApi", {
        type: 25,
        ...data
    });
};

// 修改设备分组名
export const updateDevGroupName = (data) => {
    // return $post("/user/updateDevGroupName", data);
    return $post("/user/baseApi", {
        type: 21,
        ...data
    });
};

// 删除分组
export const deleteDevGroup = (data) => {
    // return $post("/user/deleteDevGroup", data);
    return $post("/user/baseApi", {
        type: 22,
        ...data
    });
};

// 添加分组
export const addDivideDevGroup = (data) => {
    // return $post("/user/addDivideDevGroup", data);
    return $post("/user/baseApi", {
        type: 20,
        ...data
    });
};

// 批量删除设备
export const deleteGroupDevs = (data) => {
    // return $post("/user/deleteGroupDevs", data);
    return $post("/user/baseApi", {
        type: 26,
        ...data
    });
};

// 批量移动设备
export const moveOutGroupDevs = (data) => {
    // return $post("/user/moveOutGroupDevs", data);
    return $post("/user/baseApi", {
        type: 33,
        ...data
    });
};

// 查询团队的设备申请列表
export const devApplyList = (data) => {
    // return $post("/user/queryGroupDevApplyList", data);
    return $post("/user/baseApi", {
        type: 29,
        ...data
    });
};

// 处理部署设备申请
export const dealApplication = (data) => {
    // return $post("/user/approveAddingEquipment2Team", data);
    return $post("/user/baseApi", {
        type: 34,
        ...data
    });
};

// 2.3.27成员管理列表
export const accountInfo = (data) => {
    // return $post("/user/querySubAccountInfo", data);
    return $post("/user/baseApi", {
        type: 27,
        ...data
    });
};

// 修改团队成员备注
export const updateGroupSunMemo = (data) => {
    // return $post("/user/updateGroupSunMemo", data);
     return $post("/user/baseApi", {
        type: 35,
        ...data
    });
};

// 成员管理：添加子账号
export const addSubAccount = (data) => {
    // return $post("/user/addSubAccount", data);
     return $post("/user/baseApi", {
        type: 28,
        ...data
    });
};
// 注销登录 没有在用
export const userDelete = (data) => {
    return $post2("/account/delete", data);
};

// 账号注销发送邮件
export const sendEmailCode = (data) => {
    // return $post2("/email/sendCode", data);
    // return $post2("/email/delete", data);
    return $post2("/email/sendCode", data);
};
// 账号邮箱验证 没用了
export const emailValidate = (data) => {
    return $post2("/email/validate", data);
};
// 查询用户最后账单号
export const userLastOrderId = (data) => {
    // return $post("/user/getUserLastOrderId", data);
     return $post("/user/baseApi", {
        type: 9,
        ...data
    });
};
// 恢复订阅
export const subscribe = (data) => {
    return $post2("/subscribe/reinstate", data);
};
// 取消订阅
export const unsubscribe = (data) => {
    return $post2("/subscribe/deactivate", data);
};

// 收集注销原因
export const logoutReason = (data) => {
    return $post3(
        "https://sn.aomeisoftware.com/api/v1/uninstall-feedback",
        data
    );
};

// 3.3.38 新建团队角色类型
export const createTeamRole = (data) => {
    // return $post("/user/createTeamRoleType", data);
    return $post("/user/baseApi", {
        type: 38,
        ...data
    });
};

// 3.3.39删除团队角色类型
export const deleteTeamRole = (data) => {
    return $post("/user/deleteTeamRoleType", {
        type: 39,
        seq: 14,
        ...data,
    });
};

// 3.3.40查询团队角色类型列表
export const getTeamRoleList = (data) => {
    return $post("/user/queryTeamRoleTypeColumn", {
        type: 40,
        seq: 544,
        ...data,
    });
};

// 3.3.41获取隶属角色类型的分组列表
export const getRoleGroupList = (data) => {
    return $post("/user/getRolecontrollabledevicegroupinglist", {
        type: 40,
        seq: 544,
        ...data,
    });
};

// 3.3.42获取隶属角色类型的设备列表(带可控信息)
export const getRoleGoupDevList = (data) => {
    return $post("/user/getTeamEquipmentRecords", {
        type: 42,
        seq: 90,
        ...data,
    });
};

// 3.3.43保存角色设置
export const saveRoleSettings = (data) => {
    return $post("/user/saveCharacterSettings", {
        type: 43,
        seq: 14,
        ...data,
    });
};

// 3.3.44 查询团队的设备（携带控制信息）
export const queryTeamEquipment = (data) => {
    return $post("/user/queryTeamEquipment", {
        type: 44,
        seq: 544,
        ...data,
    });
};

// 3.3.45 改变团队账号角色角色类型
export const changeTeamAccountRoleType = (data) => {
    return $post("/user/changeTeamAccountRoleType", {
        type: 45,
        seq: 34,
        ...data,
    });
};

// 3.3.46 修改角色的名称
export const changeRoleName = (data) => {
    return $post("/user/changeRoleName", {
        type: 46,
        seq: 14,
        ...data,
    });
};
// 3.3.47 查询新申请设备个数
export const getNewApplied = (data) => {
    return $post("/user/queryNewlyAppliedDevicesNum", {
        type: 47,
        seq: 90,
        ...data,
    });
};

// export const emailValidate = (data) => {
//   return $post2("/email/validate", data);
// };

// menu数据
export const menu = (params) => {
    return $post("/menu", params).then((res) => {
        return res;
    });
};

// 设备列表数据
// export const deviceList = (params) => {
//   return $get("/device", params).then((res) => {
//     return res;
//   });
// };

// 用于从软件直接跳转过来的请求token
export const softLogin = (data) => {
    return $post2("/soft/login", {
        "cf-turnstile-response": "123",
        ...data,
    });
};

// 新增通用接口
export const commonApi = (data) => {
    return $post("/user/baseApi", {
        ...data
    })
}